export class ActivityMenuModel {
  constructor() {
    this.menuName = '';
    this.isEnable = false;
  }

  menuName: string;
  isEnable: boolean;
}
